<template>
  <main class="policy">
    <div class="text">
      <div class="li flex" v-for="condition in policy" :key="condition.title">
        <div class="sli top lundi">{{ condition.title }}</div>
        <div class="sli" v-html="condition.text"></div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "policy",
  data() {
    return {
      lang: "en"
    };
  },
  created() {
    if (this.$store.state.policy.length === 0) {
      this.$store.dispatch("loadPolicy");
    }
  },
  computed: {
    policy() {
      return this.$store.state.policy;
    }
  }
};
</script>

<style lang="scss" scoped>
.policy {
  font-feature-settings: none;
  display: grid;
  grid-template-columns: minmax(auto, 700px) 1fr;
  grid-gap: var(--lh);
  .top {
    // white-space: nowrap;
  }
  @media only screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    .top {
      white-space: normal;
    }
  }
}
</style>
